import { render, staticRenderFns } from "./ChangePasswordInputs.vue?vue&type=template&id=fbc88d32&"
import script from "./ChangePasswordInputs.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc88d32')) {
      api.createRecord('fbc88d32', component.options)
    } else {
      api.reload('fbc88d32', component.options)
    }
    module.hot.accept("./ChangePasswordInputs.vue?vue&type=template&id=fbc88d32&", function () {
      api.rerender('fbc88d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/UserSettings/ChangePassword/ChangePasswordInputs.vue"
export default component.exports